import { get_os_name } from '@/utils/utils_app';
import { createSlice } from '@reduxjs/toolkit';
import { DTO__app_info } from '@shared/dto/app_info/DTO__app_info';
import { ENUM__redux_slice } from '../_base/ENUM__redux_slice';
import { init_local_app_info_upsert } from './local_app_info_upsert';
import { StateAppInfo } from './state_app_info';

const initialState: StateAppInfo = {
  app_info: DTO__app_info.CREATE_STUB(),
  is_app_reloading: false,

  os_name: get_os_name(),
};

export const slice_app_info = createSlice({
  name: ENUM__redux_slice.APP_INFO,
  initialState,
  reducers: {
    upsert: init_local_app_info_upsert,
  },
  extraReducers: builder => {},
});
